import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import { Input } from '@shared/ui/input';
import { Button } from '@shared/ui/button';
export const SetPasswordView = ({ onSubmit }) => {
    const { t } = useTranslation('auth');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const schema = z
        .object({
        password: z.string().min(6, t('form.passwordMinLength')),
        confirmPassword: z.string().min(6, t('form.passwordMinLength')),
    })
        .refine((data) => data.password === data.confirmPassword, {
        message: t('setPassword.mismatch'),
        path: ['confirmPassword'],
    });
    const { register, handleSubmit, formState: { errors }, } = useForm({
        resolver: zodResolver(schema),
        defaultValues: { password: '', confirmPassword: '' },
        mode: 'onChange',
    });
    const handleFormSubmit = async (values) => {
        setIsSubmitting(true);
        try {
            await onSubmit(values.password);
        }
        finally {
            setIsSubmitting(false);
        }
    };
    return (_jsxs("div", { className: "space-y-6 py-4", children: [_jsxs("div", { className: "text-center space-y-2", children: [_jsx("div", { className: "inline-flex p-3 rounded-xl bg-primary/10 text-primary mb-2", children: _jsx(Lock, { size: 24 }) }), _jsx("h2", { className: "text-2xl font-bold text-white", children: t('setPassword.title') }), _jsx("p", { className: "text-sm text-muted-foreground", children: t('setPassword.subtitle') })] }), _jsxs("form", { className: "space-y-4", onSubmit: handleSubmit(handleFormSubmit), children: [_jsxs("div", { className: "space-y-2", children: [_jsx(Input, { id: "password", type: "password", placeholder: t('setPassword.passwordPlaceholder'), autoComplete: "new-password", className: "h-14 bg-white/5 border-white/10 focus:border-primary/50 rounded-2xl", ...register('password') }), errors.password && (_jsx("p", { className: "text-xs text-destructive px-2 font-medium", children: errors.password.message }))] }), _jsxs("div", { className: "space-y-2", children: [_jsx(Input, { id: "confirmPassword", type: "password", placeholder: t('setPassword.confirmPlaceholder'), autoComplete: "new-password", className: "h-14 bg-white/5 border-white/10 focus:border-primary/50 rounded-2xl", ...register('confirmPassword') }), errors.confirmPassword && (_jsx("p", { className: "text-xs text-destructive px-2 font-medium", children: errors.confirmPassword.message }))] }), _jsx(Button, { type: "submit", disabled: isSubmitting, className: "w-full h-14 rounded-2xl font-bold", variant: "primary", children: isSubmitting ? t('buttons.processing') : t('setPassword.submit') })] })] }));
};
